/**
 * <video-spotlight>
 *
 * Plays the spotlight video only while it's on screen (reliable muted autoplay + a perf win,
 * since off-screen videos are paused). No-op if the media is an image.
 */
class VideoSpotlight extends HTMLElement {
  #io = null;

  connectedCallback() {
    this.video = this.querySelector('video.vs__video');
    if (!this.video) return;
    this.#io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const p = this.video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            this.video.pause();
          }
        }
      },
      { threshold: 0.25 }
    );
    this.#io.observe(this);
  }

  disconnectedCallback() {
    this.#io?.disconnect();
  }
}

if (!customElements.get('video-spotlight')) {
  customElements.define('video-spotlight', VideoSpotlight);
}
